import { useEffect } from 'react'

import { getMaintenanceBypass } from '~/components/WindowVariableInjector'
import { isPlaywrightTest } from '~/utils/botDetection'

const useMaintenanceMode = (): void => {
  useEffect(() => {
    const checkMaintenanceMode = async () => {
      try {
        // Ignore everything if maintenance bypass is active or in playwright test
        if (getMaintenanceBypass() || isPlaywrightTest()) {
          return
        }

        const response = await fetch(window.location.href, {
          method: 'HEAD',
          cache: 'no-cache',
        })

        const maintenanceMode = response.headers.get('X-Pbt-Maintenance')

        // Redirect to maintenance page if maintenance mode is enabled
        if (
          maintenanceMode === 'true' &&
          !window.location.pathname.includes('maintenance-page.html')
        ) {
          window.location.href = '/maintenance-page.html'
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch maintenance mode status:', error)
      }
    }

    checkMaintenanceMode()

    const intervalId = setInterval(checkMaintenanceMode, 60000)

    return () => clearInterval(intervalId)
  }, [])
}

export default useMaintenanceMode
